export const VALIDATOR_STATS_FETCH_IN_PROGRESS = 'VALIDATOR_STATS_FETCH_IN_PROGRESS';
export const VALIDATOR_STATS_FETCH_SUCCESS = 'VALIDATOR_STATS_FETCH_SUCCESS';
export const VALIDATOR_STATS_FETCH_ERROR = 'VALIDATOR_STATS_FETCH_ERROR';
